<mat-drawer-container>
  <mat-drawer [mode]="'side'" [opened]="true" #drawer>
    <tasks-sidebar></tasks-sidebar>
  </mat-drawer>

  <mat-drawer-content>
    <div class="content">
      @if (canViewGlobaTasks()) {
        <router-outlet main></router-outlet>
      } @else {
        <div class="noop">
          <div class="noop__icons">
            <div class="noop__icons__row">
              <ts-icon icon="ts_chart-bar" size="medium" color="light-gray"></ts-icon>
              <ts-icon icon="ts_chart-line" size="medium" color="light-gray"></ts-icon>
            </div>
            <div class="noop__icons__row">
              <ts-icon icon="ts_chart-pie-alt" size="medium" color="light-gray"></ts-icon>
              <ts-icon icon="ts_robot" size="medium" color="orange"></ts-icon>
            </div>
          </div>
          <div class="noop__caption">
            <p class="noop__caption__title">Nothing to see here</p>
            <p class="noop__caption__subtitle">You can start by creating a task list</p>
          </div>
        </div>
      }
    </div>
  </mat-drawer-content>
</mat-drawer-container>
